<div class="auth" *ngIf="layout === 'auth'"  data-test="login-container-layout">

    <div class="auth__sidebar hide-for-medium-down">
        <div class="sidebar">
            <div class="sidebar__container">
                <img class="sidebar__logo" src="assets/images/jepto - white.svg"
                    alt="Jepto White Logo">
                <h2 class="sidebar__tagline mat-display-2" style="margin-bottom: 16px;">Unify your digital marketing data and management</h2>
                <p class="sidebar__sub-tagline mat-body-1">An easier way to manage and automate your marketing.</p>
                <div jepSpacer="48px"></div>
                <a href="https://www.jepto.com/" target="_blank" class="sidebar__btn-more">LEARN&nbsp;MORE</a>
            </div>
        </div>
    </div>
    <div class="auth__content">
        <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
</div>


<div class="site" *ngIf="layout === 'dashboard'" data-test="dash-container-layout" id="jep-container">
    <!-- In-app overlay anchor: dialogs render here so top bar (z-index 10050) stays above them -->
    <!-- No aria-hidden: dropdown panels/dialogs mount inside and receive focus. -->
    <div id="cdk-overlay-anchor" class="cdk-overlay-anchor"></div>
    <!-- <div class="site__ind"
        [ngClass]="[showIndicator ? 'show' : '']">  
        <jep-subscription-indicator 
            *ngIf ="showIndicator"
            [contactSupport]="contactSupport"
            [showLink]="showLink"
            [message]="subscriptionIndicatorMessage"
            [displayType]="'global'"
            [link]="'settings/subscription'"
            [iconType]="'icon-lock'"
            [theme]="subscriptionTheme"
            [linkText]="subscriptionLinkText">
        </jep-subscription-indicator>
    </div> -->
    <div class="site__navbar">
        <jep-dash-topbar></jep-dash-topbar>
    </div>
    <div class="site__sidebar" id="jep-sidebar">
        <div jepSpacer="80px"></div>
        <jep-dash-sidebar></jep-dash-sidebar>
    </div>
    <div class="site__content" [ngClass]="{'no-content-nav': noContentNav}" id="jep-content">
        <ng-container *ngTemplateOutlet="template"></ng-container>
        <div id="snackBarBox"></div>
    </div>
    <!-- jep-drawer reparent target: fixed full viewport, avoids stray grid-cell placement -->
    <div id="jep-drawer-host" class="site__drawer-host"></div>
</div>

<div class="noLayout" *ngIf="layout === 'noLayout'">
    <ng-container *ngTemplateOutlet="template"></ng-container>
</div>

<ng-template #template>
    <router-outlet> </router-outlet>
</ng-template>